import {FC, useMemo} from "react";

import {Modal} from "antd";
import {AboutModalProps} from "../../types";
import AboutForm from "./components/about-form/AboutForm";

const AboutModal: FC<AboutModalProps> = (props) => {
  const {aboutController} = props
  const {isModalOpen, selectedAboutItem, isLoading, form, toggleModal} = aboutController
  const okButtonHandler = () => {
    form.submit()
  }

  const title = useMemo(() => {
    return selectedAboutItem ? "Редагування запису" : "Створення запису"
  }, [selectedAboutItem])

  return <Modal destroyOnClose style={{top: 20}} width={1000} title={title} open={isModalOpen}
                onCancel={toggleModal} okText="Збереги" onOk={okButtonHandler}>
    <AboutForm aboutController={aboutController}/>
  </Modal>

}

export default AboutModal